import { Injectable } from '@angular/core';
import { PhoneResult } from '../models/generated/ziroModels';
import { Observable } from 'rxjs';
import { SearchAbstractResource } from '../../self-serve/resources/search/search.abstract.resource';

export class SearchPhoneQueryParams {
  q?: string;
  name?: string;
  ownerUsername?: string;
  description?: string;
  extension?: string;
  'cucm-server-id'?: number;
  limit?: number;
}

@Injectable({ providedIn: 'root' })
export class SearchPhoneResource extends SearchAbstractResource {
  get(params: SearchPhoneQueryParams): Observable<PhoneResult[]> {
    params.limit = 100;
    return this.search<PhoneResult[]>('/services/cisco/macs/phones/search', params);
  }
}
